<template>
  <section class="location-intro">
    <div class="location-intro__card">
      <div class="location-intro__gallery">
        <EntityGallery :images="gallery" :alt="detail.title" :height="320" />
      </div>

      <div class="location-intro__content">
        <h2 class="location-intro__title">{{ detail.title }}</h2>
        <dl class="location-intro__meta">
          <div
            v-for="field in detail.fields"
            :key="field.label"
            class="location-intro__meta-row"
          >
            <dt>{{ field.label }}：</dt>
            <dd>{{ field.value }}</dd>
          </div>
        </dl>
        <div class="location-intro__desc-block">
          <h4 class="location-intro__desc-title">{{ detail.introLabel || '实体介绍' }}</h4>
          <p class="location-intro__desc">{{ detail.biography }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import EntityGallery from './EntityGallery.vue'

export default {
  name: 'LocationIntro',
  components: { EntityGallery },
  props: {
    detail: { type: Object, required: true }
  },
  computed: {
    gallery() {
      return this.detail.gallery || []
    }
  }
}
</script>

<style lang="scss" scoped>
.location-intro {
  margin-bottom: $spacing-3xl;

  &__card {
    display: flex;
    gap: $spacing-xl;
    padding: $spacing-xl;
    background: $color-white;
    border-radius: 4px;
    box-shadow: 0 4px 24px rgba($color-brown-dark, 0.08);
  }

  &__gallery {
    width: 48%;
    flex-shrink: 0;
  }

  &__content {
    flex: 1;
    min-width: 0;
  }

  &__title {
    font-family: $font-serif;
    font-size: rem(28);
    font-weight: 700;
    color: $color-brown-dark;
    margin-bottom: $spacing-base;
  }

  &__meta {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: $spacing-xs $spacing-xl;
    margin-bottom: $spacing-base;
    padding-bottom: $spacing-base;
    border-bottom: 1px solid rgba($color-border, 0.5);
  }

  &__meta-row {
    display: flex;
    font-size: rem(14);
    line-height: 1.8;

    dt { color: $color-text-light; flex-shrink: 0; }
    dd { color: $color-text; }
  }

  &__desc-title {
    font-size: rem(15);
    font-weight: 600;
    color: $color-brown-dark;
    margin-bottom: $spacing-sm;
  }

  &__desc {
    font-size: rem(14);
    line-height: 1.9;
    color: $color-text-light;
  }
}

@media (max-width: 960px) {
  .location-intro__card {
    flex-direction: column;

    .location-intro__gallery { width: 100%; }
    .location-intro__meta { grid-template-columns: 1fr; }
  }
}
</style>
